import { render, staticRenderFns } from "./service-provider-name.vue?vue&type=template&id=0b84afa8"
import script from "./service-provider-name.vue?vue&type=script&lang=js"
export * from "./service-provider-name.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports